import Ajax from 'js/utils/ajax/ajax';

export const downloadReport = (url: string) => Ajax.getFileBlob(url);
